import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useMoodsContext } from "store/contexts/moodsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import { useRepliesContext } from "store/contexts/repliesContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import classNames from "classnames";

var styles = {
  emoji: {
    width: "18px",
    height: "18px",
  },
  selectedEmoji: {
    width: "100%",
    height: "100%",
  },
  emojiList: {
    display: "flex",
    listStyle: "none",
  },
  everyEmoji: {
    paddingTop: "8px",
    paddingBottom: "8px",
    borderLeft: "1px solid aliceblue",
    borderRight: "1px solid aliceblue",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  boxShadow: {
    boxShadow:
      "rgb(50 50 93 / 25%) 0px 2px 5px -1px, rgb(0 0 0 / 30%) 0px 1px 3px -1px",
    background: "white",
  },
  moodName: {
    color: "#575f6b",
    fontSize: "10px",
    width: "max-content"
  }
};

function ReplyReaction({ post, reply }) {
  const classes = styles;
  const [showMoods, setShowMoods] = useState(null);
  const { buzzes } = useMoodsContext();
  const { updateReply } = useRepliesContext();
  const { innovation_dashboard, company_id } = useTimelineContext();

  const showMoodsPooper = (event) => {
    setShowMoods(event.currentTarget);
  };

  const hideMoodsPooper = () => {
      setShowMoods(null);
  };

  const clearExpressionReaction = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    const expressionCopy = { ...reply };

    setShowMoods(null);
    if (reply.buzz_type_id) {
      expressionCopy.buzzes_count -= 1;
    }

    expressionCopy.buzz_type_id = null;

    if (innovation_dashboard)
      TeamService.clearCompanyCommentReaction(company_id, post.id, expressionCopy.id);

    if (!innovation_dashboard)
      TeamService.clearCommentReaction(post.team_id, post.id, expressionCopy.id);

    updateReply(expressionCopy);
  };

  const updateReaction = (newReactionId, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    if (newReactionId === reply?.buzz_type_id) {
      clearExpressionReaction(event);
      return;
    }

    setShowMoods(null);
    const expressionCopy = { ...reply };

    if (!reply.buzz_type_id) {
      expressionCopy.buzzes_count += 1;
    }

    expressionCopy.buzz_type_id = newReactionId;
    expressionCopy.reactions = null;

    if (innovation_dashboard)
      TeamService.reactToCompanyPostComment(
        company_id,
        post.id,
        expressionCopy.id,
        newReactionId
      );

    if (!innovation_dashboard)
      TeamService.reactToPostComment(
        post.team_id,
        post.id,
        expressionCopy.id,
        newReactionId
      );
    updateReply(expressionCopy);
  };

  let selectedMood = buzzes?.find((buzzes) => {
    return buzzes?.id === reply?.buzz_type_id;
  });

  selectedMood = selectedMood ? (
    <img
      className="mwh-16"
      style={classes.selectedEmoji}
      src={selectedMood.media}
      alt={selectedMood.name}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSmile}
      style={classes.selectedEmoji}
      className="mwh-16"
    />
  );

  return (
    <div
      style={classes.relative}
      onMouseEnter={showMoodsPooper}
      onClick={showMoodsPooper}
      onMouseLeave={hideMoodsPooper}
      className="p-like-btn"
    >
      {reply?.buzz_type_id && selectedMood}
      {!reply?.buzz_type_id && (
        <FontAwesomeIcon
          className="mwh-16"
          style={classes.selectedEmoji}
          icon={faSmile}
        />
      )}
      <CSSTransition
        in={Boolean(showMoods)}
        timeout={300}
        unmountOnExit
        classNames="reaction-element"
      >
        <ClickAwayListener onClickAway={hideMoodsPooper}>
          <div style={classes.boxShadow} className="postMoods commentMoods">
            <ul className="reactionEmojies" style={classes.emojiList}>
              {buzzes?.map((mood) => (
                <li
                  className={classNames({
                    "emoji-mood": true,
                    "singleEmoji": true,
                    "selected_emoji_mood": reply.buzz_type_id === mood.id ? true : false,
                  })}
                  onClick={(e) => updateReaction(mood.id, e)}
                  key={mood.name}
                  style={classes.everyEmoji}
                >
                  <img
                    src={mood.media}
                    alt={mood.name}
                    key={mood.id}
                    style={classes.emoji}
                  />
                  <span style={classes.moodName}>{mood.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
}

export default ReplyReaction;
